import React, {createContext, useState, type SetStateAction, type FC} from 'react'
import type {WithChildren} from '../../_metronic/helpers'
import moment from 'moment'
import {QueryObserverResult, RefetchOptions, RefetchQueryFilters} from 'react-query'
import {Option} from 'react-multi-select-component'
import {useDashboardData} from '../../pages/kpi/dashboard/hooks/getDataDashboard'
import {IParsedDashboard} from '../../pages/kpi/dashboard/utils/parseDashboard'

export interface DashboardContextType {
  currentInitDta: string
  setCurrentInitDta: React.Dispatch<React.SetStateAction<string>>

  currentEndDta: string
  setCurrentEndDta: React.Dispatch<React.SetStateAction<string>>

  choosedDtaInit: Date
  setChoosedDtaInit: React.Dispatch<SetStateAction<Date>>

  choosedDtaEnd: Date
  setChoosedDtaEnd: React.Dispatch<SetStateAction<Date>>

  selectsfranchises: Option[]
  setSelectsfranchises: React.Dispatch<SetStateAction<Option[]>>

  selectsfranchisesSearchKpi: string
  setSelectsfranchisesSearchKpi: React.Dispatch<SetStateAction<string>>

  query: {
    data: IParsedDashboard | undefined
    isLoading: boolean
    error: unknown
    refetch: <TPageData>(
      options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
    ) => Promise<QueryObserverResult<any, unknown>>
  }
}

const DashboardContext = createContext<DashboardContextType>({} as DashboardContextType)

const DashboardProvider: FC<WithChildren> = ({children}) => {
  const [currentInitDta, setCurrentInitDta] = useState<string>(
    moment().startOf('month').format('YYYY-MM-DD')
  )

  const [currentEndDta, setCurrentEndDta] = useState<string>(moment().format('YYYY-MM-DD'))
  const now = new Date()
  const [choosedDtaInit, setChoosedDtaInit] = useState<Date>(
    new Date(now.getFullYear(), now.getMonth(), 1)
  )
  const [choosedDtaEnd, setChoosedDtaEnd] = useState<Date>(new Date())

  const [selectsfranchises, setSelectsfranchises] = useState<Option[]>([])
  const [selectsfranchisesSearchKpi, setSelectsfranchisesSearchKpi] = useState<string>('')

  const {data, isLoading, error, refetch} = useDashboardData(
    currentInitDta,
    currentEndDta,
    selectsfranchisesSearchKpi
  )

  return (
    <DashboardContext.Provider
      value={{
        currentInitDta,
        currentEndDta,

        setCurrentInitDta,
        setCurrentEndDta,

        setChoosedDtaInit,
        setChoosedDtaEnd,

        choosedDtaInit,
        choosedDtaEnd,

        selectsfranchises,
        setSelectsfranchises,

        selectsfranchisesSearchKpi,
        setSelectsfranchisesSearchKpi,

        query: {
          data,
          error,
          isLoading,
          refetch,
        },
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export {DashboardProvider, DashboardContext}
